import { module } from 'modujs';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); 

export default class extends module {
    constructor(m) {
        super(m);
        this.tl = null;
    }

    init() {
      
      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.el,
          start: "top top", // when the top of the trigger hits the top of the viewport
          end: "bottom top",
          scrub: 0.5
        },
      });

      // add animations and labels to the timeline
      this.tl.add("start")
      .fromTo(this.$('home-hero-small')[0], { y: '0%' }, { y: '50%'}, 'start')
      .fromTo(this.$('home-hero-large')[0], { y: '0%' }, { y: '8%'}, 'start')

    }

    destroy() {
      if(this.tl) {
        this.tl.kill();
        this.tl = null;
      }
    }
}
